<template lang="html">
  <v-page class="page-register" :profile="profile">
    <v-card class="card-register">
      <v-inner>
        <v-logo class="mb-4" />
        <!-- <v-text tag="h2" class="h4 title center mb-3">Crie sua conta</v-text> -->
        <v-text tag="h2" class="h4 title center mt-2 mb-4"
          >Confirme seu cadastro</v-text
        >
        <v-input type="text" id="signup-first-name" v-model="freelancer.name"
          >Nome</v-input
        >
        <v-input type="text" id="signup-last-name" v-model="freelancer.lastname"
          >Sobrenome</v-input
        >
        <v-input type="email" id="signup-email" v-model="freelancer.email"
          >E-mail</v-input
        >
        <v-input
          type="select"
          v-model="freelancer.profile"
          :options="profilesName"
          placeholder="Seu perfil"
        ></v-input>
        <v-input
          type="select"
          v-model="freelancer.focus"
          :options="focusName"
          placeholder="Seu foco"
        ></v-input>
        <v-input
          type="select"
          v-model="freelancer.year_exp"
          :options="yearExp"
          placeholder="Sua experiência"
        ></v-input>

        <v-row :size="1">
          <v-col :md="6">
            <v-input
              type="password"
              id="signup-password"
              v-model="freelancer.password"
              >Senha</v-input
            >
          </v-col>
          <v-col :md="6">
            <v-input
              type="repassword"
              id="signup-repassword"
              :repassword="freelancer.password"
              v-model="freelancer.confirm_password"
              >Repetir senha</v-input
            >
          </v-col>
        </v-row>
        <small>
          <v-input
            type="checkbox"
            id="login-remember"
            v-model="freelancer.accepted_term"
          >
            Declaro que li e concordo com os
            <v-link :to="{ name: 'accept' }" target="_blank"
              >termos de aceite da plataforma Vibbra</v-link
            >
          </v-input>
        </small>
        <v-button
          class="block primary"
          @click="confirm()"
          :disabled="isDisabled"
          >Criar conta</v-button
        >
      </v-inner>
    </v-card>
  </v-page>
</template>

<script>
import apiFreelancer from '@/api/public';

export default {
  props: {
    profile: {
      default: 'vibbrante',
    },
    freelancer: Object,
    roles: [],
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      apiFreelancer
        .freelancer(this.$route.params.id)
        .then(response => {
          this.freelancer = response.data.freelancer;
          this.roles = response.data.roles;
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    confirm() {
      apiFreelancer
        .confirm(this.freelancer, this.$route.params.id)
        .then(response => {
          if (response.status === 200) {
            this.$router.push({ name: 'vibbrant-login' });
          }
        })
        .catch(e => {
          this.$children[0].showErrorMsg({ message: e });
        });
    },
  },
  computed: {
    isDisabled() {
      return !(
        this.freelancer.accepted_term &&
        this.freelancer.profile &&
        this.freelancer.focus &&
        this.freelancer.year_exp &&
        this.freelancer.password &&
        this.freelancer.confirm_password &&
        this.freelancer.password === this.freelancer.confirm_password
      );
    },
    yearExp() {
      return ['3 a 5 anos', '6 a 9 anos', '10+ anos'];
    },
    profilesName() {
      const names = [];
      this.roles.forEach(element => {
        names.push(element.name);
      });
      return names;
    },
    focusName() {
      const names = [];
      this.roles.forEach(element => {
        element.focus.forEach(foco => {
          if (
            element.name === this.freelancer.profile ||
            this.freelancer.profile === ''
          ) {
            names.push(foco);
          }
        });
      });
      return names;
    },
  },
};
</script>

<style lang="scss">
.page-register {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .card-register {
    flex-basis: auto;
    flex-grow: 1;

    .logo {
      height: 60px;
      text-align: center;
      margin: 0 0 30px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/pages/freelancer.vue